import { Injectable, inject } from '@angular/core';
import {HttpEvent, HttpHandler, HttpHeaders, HttpInterceptor, HttpRequest} from '@angular/common/http';
import { Observable } from 'rxjs';
import {UserContextService} from '../services/user-context.service';
import {AuthService} from '../auth/services/auth.service';
import {APP_CONFIG} from '../config/app-config.token';
import {AppConfig} from '../config/app-config.model';

@Injectable()
export class AuthHeaderInterceptor implements HttpInterceptor {
  private userContext = inject(UserContextService);
  private authService = inject(AuthService);
  private config = inject<AppConfig>(APP_CONFIG);


  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {

    // Bypass Saviscio Requests
    if (req.url.includes('saviscio')) { return next.handle(req); }

    // Bypass Keycloak requests — token endpoint, discovery document, etc.
    // Keycloak does not allow X-Ssin in its CORS policy, and Bearer is not needed there.
    if (req.url.includes(this.config.keycloakRootUrl)) { return next.handle(req); }

    let clonedRequest = req.clone();

    // Use unified UserContextService for auth checks
    const isInternalUser = this.userContext.isInternalUser();
    const inss = this.userContext.getInss();

    const token = this.authService.getAccessToken();
    if (token) {
      clonedRequest = clonedRequest.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`
        }
      });
    }

    // Add X-Ssin header for external users (required by backend)
    if (!isInternalUser && inss) {
      const originalHeaders: HttpHeaders = clonedRequest.headers;
      clonedRequest = clonedRequest.clone({
        headers: originalHeaders.append('X-Ssin', inss)
      });
    }

    return next.handle(clonedRequest);
  }
}
